var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"most-popular-products-wrapper"},[_c('transition',{attrs:{"name":"mv"}},[(_vm.list.length > 0)?_c('ul',_vm._l((_vm.list),function(li){return _c('li',[_vm._v("\n\t\t\t\t"+_vm._s(li)+"\n\t\t\t")])}),0):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0f84a87a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/MostPopularProducts.vue
// module id = 68lO
// module chunks = 1